/**
 * Build-time environment helpers.
 *
 * `VITE_APP_ENV` is baked into the SPA bundle (Terraform output →
 * staging-deploy workflow → Vite), same flow as VITE_API_URL. Values:
 * `staging` | `production`. Anything other than `production` (incl.
 * missing, e.g. local dev) is treated as a non-production environment
 * so the "Test mode" banner (CLAUDE.md §9) shows by default.
 */
export function appEnv(): string {
  const env: unknown = import.meta.env.VITE_APP_ENV;
  return typeof env === 'string' && env.length > 0 ? env : 'localdev';
}

export function isProduction(): boolean {
  return appEnv() === 'production';
}
